const sortValuesBeautifulPhone = () => {
  return [
    {
      name: 'All',
      id: '0',
    },
    {
      name: '055',
      id: '1',
    },
    {
      name: '099',
      id: '2',
    },
  ];
};

export default sortValuesBeautifulPhone;
